<template>
	<div>
		<v-stage ref="stage"
				 :config="configKonva"
				 >

			<v-layer ref="layer" >
				<v-line ref="figure" :config="{
							x: configKonva.width/2 - 900/2,
							y: 200,
							points: this.points,
							tension: 0.4,
							closed: true,
							fill: '#ffffff',
							shadowBlur: 20,
							shadowColor: 'rgba(134, 184, 227, 0.19)'
						  }"
				></v-line>
			</v-layer>
			<v-layer ref="dragLayer"></v-layer>
		</v-stage>
	</div>
</template>

<script>
    import Vue from 'vue';
    import Bus from '../bus';
    import VueKonva from 'vue-konva';
    Vue.use(VueKonva);

    const width = window.innerWidth;
    const height = 900 /*window.innerHeight*/;
    let vm = {};
    export default {
        name: "canvasy",
        data() {
            return {
                list: [],
                configKonva: {
                    width: width,
                    height: height
                },
                points: [135,20, 425,0, 738,39, 899,180, 827,350,  600,530, 360,550, 205,450, 130,350, 2,240, 20,100],
				pointsShape:[]
            };
        },
        methods: {
            randomInteger(min, max) {
                var rand = min + Math.random() * (max + 1 - min);
                rand = Math.floor(rand);
                return rand;
            },
    		transform(){
                this.pointsShape = this.points.map(elem => {
                    return this.randomInteger(elem * 0.98, elem * 1.08)
				});

                let tween = new Konva.Tween({
                    node: this.$refs.figure.getStage(),
                    duration: 1,
                    x: this.configKonva.width/2 - 900/2,
                    y: 200,
                    points: this.pointsShape,
                    tension: 0.4,
                    closed: true,
                });
                setTimeout(function() {
                    tween.play();
                }, 200);
			},
            handleResize(){
                this.configKonva.width = window.innerWidth;
            }
        },
        mounted() {
            Bus.$on('tab-click', ()=>{
                this.transform();
			});
        },
        created() {
            window.addEventListener('resize', this.handleResize);
        },

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/canvasy.vue